import { Box, CardMedia } from "@mui/material";
import { useTableLayoutClasses } from "../TableLayout.style";
import { BomItemDetails } from "../../../../../explorer/types/SpareParts/BomItemDetails";
import ImageTooltip from "../../../AppTooltip/ImageTooltip";
import { PARTS_RESOURCES } from "../../../../configuration/Resources";

type TPartSketchThumbnailComponent = {
    item: any;
};

const PartSketchThumbnailComponent = (props: TPartSketchThumbnailComponent) => {
    const classes = useTableLayoutClasses();
    const sketch = props.item.images?.find(
        (i: { imageType: string; }) => i?.imageType === "sketch"
    )?.fileName;
    return (
        <Box sx={[classes.columnReplaced]}>
            {sketch && sketch !== "" && (
                <ImageTooltip
                    imageStyle={{ height: 350 }}
                    imagePath={`${PARTS_RESOURCES}/${sketch?.substring(
                        0,
                        2
                    )}/${sketch}.jpg`}
                >
                    <CardMedia
                        component="img"
                        sx={{ width: 50 }}
                        image={`${PARTS_RESOURCES}/${sketch?.substring(
                            0,
                            2
                        )}/${sketch}.thumb.300.jpg`}
                    />
                </ImageTooltip>
            )}
        </Box>
    );
};

export default PartSketchThumbnailComponent;
